/** Score breakdown row builders, kept apart from the component. */

import type { PairScoreDetails, RecipeScoreDetails } from '@/api/types'

export interface ScoreRow {
  label: string
  utility: number
  exploration: number
  penalty?: number
  total: number
}

export function pairRows(
  details: PairScoreDetails,
  meal1Name: string,
  meal2Name: string,
): ScoreRow[] {
  return [
    sideRow(meal1Name, details.meal1_utility, details.meal1_exploration),
    sideRow(meal2Name, details.meal2_utility, details.meal2_exploration),
    penaltyRow('Combined effort', details.pair_penalty, details.total_score),
  ]
}

export function recipeRows(
  details: RecipeScoreDetails,
  recipeName: string,
): ScoreRow[] {
  return [sideRow(recipeName, details.utility, details.exploration)]
}

function sideRow(label: string, utility: number, exploration: number): ScoreRow {
  return {
    label,
    utility,
    exploration,
    total: utility + exploration,
  }
}

function penaltyRow(label: string, penalty: number, total: number): ScoreRow {
  return { label, utility: 0, exploration: 0, penalty, total }
}
